exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".div-padding {\n  padding-left: 15px; }\n\n.header-margin {\n  margin-top: 1rem;\n  margin-left: 18px; }\n\n.span-margin {\n  margin-left: 0px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/fleet/fleet-embed.scss
// module id = +fzn
// module chunks = 0